/**
 * Creating a standalone constants file for query parameters to make it easy to
 * locate and catalogue the various query string parameters.
 * NOTE: When adding a new query parameter dont forget to add it to the canvas
 * bridge like so: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/67098/overview
 */

export const QUERY_PARAM_LINKED_OBJECT_ID = 'whiteboard-linked-object';

export const QUERY_PARAM_LINKED_MENTION_ID = 'focusedMentionId';

export const QUERY_PARAM_LANGUAGE_LOCALE = 'whiteboard-locale';

export const QUERY_PARAM_DISABLE_WEBGL = 'noWebGl';

export const QUERY_PARAM_ENABLE_GPU_PROFILING = 'gpuProfiling';

export const QUERY_PARAM_ENABLE_DEBUG_MODE = 'debug';

export const QUERY_PARAM_ENABLE_DEVTOOLS = 'devTools';

export const QUERY_PARAM_HEADLESS_MODE = 'headless';

export const QUERY_PARAM_DARK_FEATURES = 'df';

export const QUERY_PARAM_FEATURE_FLAGS = 'ff';

export const QUERY_PARAM_EXPERIMENT_PARAMS = 'ep';

export const QUERY_PARAM_PRINT_FEATURE_FLAGS = 'printFF';

export const QUERY_PARAM_PARENT_PRODUCT = 'parentProduct';

export const QUERY_PARAM_EMBED = 'embed';

export const QUERY_PARAM_SLIDES = 'slides';

export const QUERY_PARAM_PRESENTATION_MODE = 'presentationMode';

export const QUERY_PARAM_FOCUSED_COMMENT_ID = 'focusedCommentId';

export const QUERY_PARAM_REPLY_TO_COMMENT = 'replyToComment';

export const QUERY_PARAM_DEBUG_LAYOUTS = 'debugLayouts';

export const QUERY_PARAM_HIDE_UI = 'hideUi';

export const QUERY_PARAM_HIDE_CURSORS = 'hideCursors';

export const QUERY_PARAM_HIDE_MAIN_TOOLBAR = 'hideMainToolbar';

export const QUERY_PARAM_HIDE_BORDER = 'hideBorder';

export const QUERY_PARAM_ENABLE_BECSY_ANALYZER = 'becsyAnalyzer';

export const QUERY_PARAM_ENABLE_BECSY_ANALYSER = 'becsyAnalyser';

export const QUERY_PARAM_ENABLE_BECSY_LOGS = 'becsyLogs';

export const QUERY_PARAM_FORCE_PAN_AND_ZOOM = 'forcePanAndZoom';

export const QUERY_PARAM_NATIVE_EMBED_FULLSCREEN = 'nativeEmbedFullscreen';

export const TEMPLATE_VR_URL_PARAM_KEY = 'templateKey';

export const QUERY_PARAM_STATEFUL_BUG_DETECTOR = 'statefulBugDetector';

export const QUERY_PARAM_RELIABILITY_LOGS = 'reliability';

export const QUERY_PARAM_RACING = 'racing';

export const QUERY_PARAM_AUTO_IMPORT_JIRA_ISSUES = 'autoImportJiraIssues';

export const QUERY_PARAM_OPEN_JIRA_IMPORT_TOOL = 'openJiraImportTool';

export const QUERY_PARAM_OPEN_MIRO_IMPORT_TOOL = 'openMiroImportTool';

export const QUERY_PARAM_OPEN_MURAL_IMPORT_TOOL = 'openMuralImportTool';

export const QUERY_PARAM_OPEN_TEMPLATE_PICKER = 'openTemplatePicker';

export const QUERY_PARAM_JIRA_IMPORT_JQL = 'jiraImportJql';

export const QUERY_PARAM_CLOUD_ID = 'cloudId';

export const QUERY_PARAM_PROJECT_UUID = 'projectUuid';

export const QUERY_PARAM_INSERT_TEMPLATE_WITH_KEY = 'insertTemplateWithKey';

export const QUERY_PARAM_CREATED_FROM_SLUG = 'createdFromSlug';

export const QUERY_PARAM_REPORT_TO_MCP = 'reportToMCP';

export const QUERY_PARAM_INITIAL_THEME = 'initial-theme';

export const QUERY_PARAM_DISABLE_CANVAS_SCROLL = 'disableCanvasScroll';

export const QUERY_PARAM_SHOW_BLANK_CREATION_EXPERIENCE = 'showBlankCreationExperience';
